/* Kollektions-Filter 4b: Rahmenfarbe · Dacheindeckung · Farbe – filtert Karten client-seitig */
(function(){
var root=document.getElementById('tpf');if(!root)return;
var grid=document.querySelector('.pgrid');if(!grid)return;
var cards=[].slice.call(grid.querySelectorAll('.pcard2[data-tpf]'));
var st={r:'',dach:'',farbe:''};
function minPrice(list){var m=null;list.forEach(function(c){var p=parseInt(c.getAttribute('data-min')||'0',10);if(p&&(m===null||p<m))m=p});return m}
function fmt(cents){return Math.round(cents/100).toLocaleString('de-DE')+' \u20ac'}
function apply(){
 var n=0,shown=[];
 var fl=root.querySelector('[data-farbe-label]');if(fl)fl.textContent=st.dach==='vsg'?'Glasfarbe':st.dach==='steg'?'Plattenfarbe':'Farbe';
 [].slice.call(root.querySelectorAll('.tpf-sw button')).forEach(function(b){var f=b.getAttribute('data-for')||'';var show=!st.dach||f.indexOf(st.dach)>-1;b.hidden=!show;if(!show&&b.classList.contains('on')){b.classList.remove('on');st.farbe=''}});
 var lbl=root.querySelector('.tpf-swl');if(lbl)lbl.textContent=st.farbe||'Alle';
 cards.forEach(function(c){
  var ok=(!st.r||c.getAttribute('data-rahmen')===st.r)&&(!st.dach||c.getAttribute('data-dach')===st.dach)&&(!st.farbe||c.getAttribute('data-farbe')===st.farbe);
  c.classList.toggle('tpf-hide',!ok);if(ok){n++;shown.push(c)}
 });
 root.querySelector('.tpf-n').textContent=n;grid.classList.toggle('tpf-none',n===0);
 var mp=minPrice(shown),ab=root.querySelector('.tpf-ab');if(ab)ab.style.visibility=mp?'visible':'hidden';if(mp)root.querySelector('.tpf-ab b').textContent=fmt(mp);
 var active=st.r||st.dach||st.farbe;root.querySelector('.tpf-reset').hidden=!active;
 try{sessionStorage.setItem('tpf:'+location.pathname,JSON.stringify(st))}catch(e){}
}
function sync(){
 [].slice.call(root.querySelectorAll('button[data-k]')).forEach(function(b){var k=b.getAttribute('data-k'),v=b.getAttribute('data-v');if(k==='reset')return;b.classList.toggle('on',st[k]===v)});
}
root.addEventListener('click',function(e){
 var b=e.target.closest('button[data-k]');if(!b)return;var k=b.getAttribute('data-k'),v=b.getAttribute('data-v');
 if(k==='reset'){st={r:'',dach:'',farbe:''};sync();apply();return}
 if(k==='dach'){st.dach=v;}else{st[k]=st[k]===v?'':v}
 sync();apply();
});
try{var saved=JSON.parse(sessionStorage.getItem('tpf:'+location.pathname)||'null');if(saved&&typeof saved.r==='string')st=saved}catch(e){}
sync();apply();
})();
